export interface CartSummaryResponse {
  count: number
  totalPrice: number
}

export function parseCartSummaryResponse(raw: any): CartSummaryResponse {
  if (!raw || typeof raw !== 'object') {
    throw new Error('Invalid response format: expected object')
  }

  if (typeof raw.count !== 'number') {
    throw new Error('Invalid response format: count must be a number')
  }

  if (typeof raw.total_price !== 'number') {
    throw new Error('Invalid response format: total_price must be a number')
  }

  return {
    count: raw.count,
    totalPrice: raw.total_price,
  }
}
